import { createSelector } from '@reduxjs/toolkit';
import { getProfile } from './getProfile';

export const getExecutorType = createSelector(getProfile, (profile) => profile?.executorType);
